import { useMemo } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useCoordinatedAgents } from "@/hooks/useCoordinatedAgents";

export interface CoordinatorTeamAgent {
  agentId: string;
  fullName: string;
}

export function useCoordinatorTeam(): { agents: CoordinatorTeamAgent[]; loading: boolean } {
  const { user, activeWorkspaceId } = useAuth();
  const { data, isLoading } = useCoordinatedAgents();

  const agents = useMemo(
    () =>
      (data || [])
        .filter((r) =>
          r.coordinator_user_id === user?.id
          && r.user_id !== user?.id
          && r.workspace_id === activeWorkspaceId)
        .map((r) => ({ agentId: r.agent_id, fullName: r.full_name || r.email || "Agente" }))
        .sort((a, b) => a.fullName.localeCompare(b.fullName, "es")),
    [data, user?.id, activeWorkspaceId],
  );

  return { agents, loading: isLoading };
}
